import React from 'react';
import { map } from 'lodash';
import './tags.scss';

class TagsView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  getTags = () => {
    let { tags } = this.props.data;
    return tags || [];
  };

  handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    let tags = this.getTags();
    if (tags.length > 1) {
      this.setState({
        open: true,
        anchorEl: event.currentTarget,
      });
    }
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    let tags = this.getTags();
    if (!tags.length) {
      return null;
    }
    return (
      <div className="tags-wrapper">
        {map(tags, (t, i) => (
          <div key={i} className="tag-chip">
            #{t}
          </div>
        ))}
      </div>
    );
  }
}

export default TagsView;
